import { Alert, Text, Box, AlertIcon, VStack, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = {
  error?: string;
};

const PageError = ({ error = undefined }: Props) => {
  const { t } = useTranslation();
  return (
    <Box flex="none">
      <Alert status="error" borderRadius="15px" boxShadow="2xl">
        <VStack>
          <HStack>
            <AlertIcon />
            <Text pl="12px">{error || t('estimate.error')}</Text>
          </HStack>
        </VStack>
      </Alert>
    </Box>
  );
};

export default PageError;
